import { Loader } from 'components/Loader/Loader';
import { Dayjs } from 'dayjs';
import React, { useState } from 'react';
import { CalendarFetchByDay } from '../../../components/OrderListTable/CalendarFetch/CalendarFetchByDay';
import { useGetPerformanceScanListByTime } from '../../../hooks/useGetPerformanceScanByTimeList';
import { Region } from '../../../types/orderTypes';
import { ScanMenuButtons } from '../ScanPerformanceList/ScanMenuButtons/ScanMenuButtons';
import { showDayByHourOfDay } from '../ScanPerformanceList/showDayByHourOfDay';
import { ScanPerformanceByTimeListComponent } from './ScanPerformanceByTimeListComponent';
import { Helmet } from 'react-helmet';

export function ScanPerformanceByTimeList({
  region,
}: {
  region?: Region;
}): JSX.Element {
  const dayToSHow: Dayjs = showDayByHourOfDay();
  const [startDate, setStartDate] = useState(dayToSHow);

  const { performanceScanList, isLoading } = useGetPerformanceScanListByTime(
    startDate,
    startDate
  );

  const fetchValues = (givenDate: Dayjs) => {
    setStartDate(givenDate);
  };

  return (
    <div>
      <Helmet>
        <title>Monitor - Scan Graphs</title>
      </Helmet>
      <ScanMenuButtons />
      <CalendarFetchByDay
        fetchValues={fetchValues}
        givenDate={startDate}
        trackingName={'Monitor-scan'}
      />
      {isLoading === true && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Loader type="spinner" size="large" />
        </div>
      )}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          marginRight: '200px',
        }}
      />
      {isLoading === false && (
        <ScanPerformanceByTimeListComponent
          performanceScanList={performanceScanList}
        />
      )}
    </div>
  );
}
